import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

enum Controls {
  Note = 'note',
}

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './add-notes-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class AddNotesDialogComponent {
  readonly Controls = Controls;
  heading = 'Add Notes';
  notesFormGroup: FormGroup;
  defaultRows = 3;

  constructor(
    public dialogRef: MatDialogRef<AddNotesDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const existingNote = this.data?.note;
    this.notesFormGroup = this.formBuilder.group({
      [Controls.Note]: new FormControl(existingNote)
    });
  }

  onClickSave(): void {
    const note = this.notesFormGroup.get(Controls.Note).value;
    this.dialogRef.close(note);
  }

  onClickCancel(): void {
    this.dialogRef.close(this.data?.note);
  }

}
